// Email templates & notification admin (notification-center-service):
//   Templates  — per kind: MJML editor, preview, test send, publish (platform admins)
//   Sent emails — what went out / failed, per org (admins + support)
//   Opt-outs   — unsubscribed addresses (admins + support)
//   Settings   — kill switch, dry run, marketing daily cap (platform admins)
import React, {useEffect, useState} from 'react';
import {Alert, Box, Tab, Tabs} from '@mui/material';

import {getFromLocalStorage} from '../../lib/utils';
import {listTemplates} from '../../actions/notifications';
import {canEditTemplates, errorMessage} from '../../lib/notifications';
import TemplatesTab from './TemplatesTab';
import TemplateEditor from './TemplateEditor';
import SentEmailsTab from './SentEmailsTab';
import OptOutsTab from './OptOutsTab';
import SettingsTab from './SettingsTab';

const EmailTemplates = () => {
  const admin = canEditTemplates(getFromLocalStorage().role);
  const tabs = admin ? ['templates', 'sent', 'optouts', 'settings'] : ['sent', 'optouts'];
  const [tab, setTab] = useState(tabs[0]);
  const [kinds, setKinds] = useState([]);
  const [open, setOpen] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!admin) return;
    listTemplates().then((res) => setKinds(res.kinds || [])).catch((e) => setError(errorMessage(e)));
  }, [admin, open]);

  return (
    <Box sx={{p: {xs: 1, md: 2}}}>
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{mb: 2}}>
        {admin && <Tab value="templates" label="Templates" />}
        <Tab value="sent" label="Sent emails" />
        <Tab value="optouts" label="Opt-outs" />
        {admin && <Tab value="settings" label="Settings" />}
      </Tabs>
      {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
      {tab === 'templates' && (open
        ? <TemplateEditor kind={open} onBack={() => setOpen(null)} />
        : <TemplatesTab kinds={kinds} onOpen={setOpen} />)}
      {tab === 'sent' && <SentEmailsTab kinds={kinds} />}
      {tab === 'optouts' && <OptOutsTab />}
      {tab === 'settings' && <SettingsTab />}
    </Box>
  );
};

export default EmailTemplates;
